import React, { useState } from 'react';
import { ArrowLeft, X, Info, AlertCircle, Package, CheckCircle, RefreshCw, Clock, Save, Plus, Server } from 'lucide-react';
import { OutputDataStructure, OutputProperty } from './OutputDataStructure';
import { ToolSelection } from './ToolSelection';
import { AddMCPServerModal } from './AddMCPServerModal';
export const ActionDetailsPanel = ({
  onClose,
  onShowActionSelection,
  onShowTestPanel
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showTestPanel, setShowTestPanel] = useState(false);
  const [outputProperties, setOutputProperties] = useState<OutputProperty[]>([]);
  const [showToolSelection, setShowToolSelection] = useState(false);
  const [showAddMCPModal, setShowAddMCPModal] = useState(false);
  // State for editable content
  const [instructionsPrompt, setInstructionsPrompt] = useState(`1. Analyze the inventory data to identify any items with stock levels below 20 units.
2. For each item identified, determine the corresponding supplier responsible for restocking that item.
3. Draft a personalized restock order email for each supplier, including the following details:
   - The item(s) that need restocking.
   - The current stock levels and the recommended restock quantity.
   - A polite request to confirm the order and provide an estimated delivery date.
4. Send the email to the respective supplier.`);
  const [requireApprovals, setRequireApprovals] = useState(true);
  const handleRunTest = () => {
    setShowWarningModal(false);
    setShowTestPanel(true);
    // Also call the parent component's onShowTestPanel if provided
    if (typeof onShowTestPanel === 'function') {
      onShowTestPanel();
    }
  };
  const handleToggleApprovals = () => {
    setRequireApprovals(!requireApprovals);
  };
  const handleAddMCPServer = serverData => {
    console.log('Adding MCP server:', serverData);
    // Here you would implement the actual logic to add the server
  };
  return <div className="w-[400px] border-r border-gray-200 bg-white flex flex-col h-full" data-id="element-9">
      <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-10">
        <div className="flex items-center" data-id="element-11">
          <button onClick={onShowActionSelection} className="mr-3 text-gray-500 hover:text-gray-700" data-id="element-12">
            <ArrowLeft className="w-5 h-5" data-id="element-13" />
          </button>
          <span className="text-gray-700 font-medium" data-id="element-14">
            Back to action selection
          </span>
        </div>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-15">
          <X className="w-5 h-5" data-id="element-16" />
        </button>
      </div>
      <div className="p-4 border-b border-gray-200" data-id="element-17">
        <div className="flex items-center mb-4" data-id="element-18">
          <div className="w-8 h-8 bg-teal-400 rounded flex items-center justify-center mr-3 flex-shrink-0" data-id="element-19">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-20">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-21" />
            </svg>
          </div>
          <div data-id="element-22">
            <div className="text-xs text-gray-500" data-id="element-23">AI Custom Agent</div>
            <div className="text-sm font-medium" data-id="element-24">
              Delegate to AI Custom Agent
            </div>
          </div>
        </div>
      </div>
      <div className="overflow-y-auto flex-1" data-id="element-25">
        <div className="p-4" data-id="element-26">
          <div className="mb-6" data-id="element-27">
            <div className="flex justify-between items-center mb-2" data-id="element-28">
              <h3 className="text-sm font-medium text-gray-800" data-id="element-29">
                Instructions
              </h3>
              <Info className="w-4 h-4 text-gray-400" data-id="element-30" />
            </div>
            <textarea className="w-full p-3 border border-gray-200 rounded-md bg-white h-60 resize-none text-sm" value={instructionsPrompt} onChange={e => setInstructionsPrompt(e.target.value)} data-id="element-31"></textarea>
          </div>
          <div className="mb-6" data-id="element-32">
            <div className="p-3 border border-gray-200 rounded-md bg-gray-50" data-id="element-33">
              <div className="flex items-center justify-between" data-id="element-34">
                <div data-id="element-35">
                  <div className="text-sm text-gray-700" data-id="element-36">Require approvals</div>
                  <div className="text-xs text-gray-500" data-id="element-37">
                    Review and confirm agent actions
                  </div>
                </div>
                <div className={`w-10 h-5 ${requireApprovals ? 'bg-blue-500' : 'bg-gray-300'} rounded-full relative cursor-pointer`} onClick={handleToggleApprovals} data-id="element-38">
                  <div className={`absolute ${requireApprovals ? 'right-1' : 'left-1'} top-1 w-3 h-3 bg-white rounded-full transition-all`} data-id="element-39"></div>
                </div>
              </div>
            </div>
          </div>
          {/* Tool Selection Section */}
          <div className="mb-6 border border-gray-200 rounded-md" data-id="element-40">
            <div className="p-3 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-41">
              <h2 className="text-sm font-medium text-gray-800" data-id="element-42">
                Available tools
              </h2>
              <Info className="w-4 h-4 text-gray-400" data-id="element-43" />
            </div>
            {!showToolSelection ? <div className="p-3" data-id="element-44">
                <button className="w-full px-4 py-2 border border-gray-200 rounded-md text-sm font-medium flex items-center justify-center" onClick={() => setShowToolSelection(true)} data-id="element-45">
                  <span data-id="element-46">Configure Available Tools</span>
                </button>
              </div> : <ToolSelection onClose={() => setShowToolSelection(false)} onAddMCPServer={() => setShowAddMCPModal(true)} data-id="element-47" />}
          </div>
          {/* Output Data Structure */}
          <OutputDataStructure properties={outputProperties} onPropertiesChange={setOutputProperties} readOnly={false} data-id="element-48" />
          {/* Run to Test link - moved above the action buttons and made less prominent */}
          <div className="flex justify-end mb-4" data-id="element-49">
            <button className="text-sm text-gray-500 hover:text-gray-700 underline" onClick={() => setShowWarningModal(true)} data-id="element-50">
              Run to Test
            </button>
          </div>
        </div>
      </div>
      {/* Action buttons - fixed at bottom */}
      <div className="p-4 border-t border-gray-200 flex justify-end space-x-4" data-id="element-51">
        <button className="px-4 py-2 border border-gray-200 rounded-md text-sm font-medium" onClick={onClose} data-id="element-52">
          Cancel
        </button>
        <button className="px-4 py-2 bg-gray-700 text-white rounded-md text-sm font-medium" data-id="element-53">
          Save
        </button>
      </div>
      {/* Warning Modal */}
      {showWarningModal && <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50" data-id="element-54">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-55">
            <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-56">
              <AlertCircle className="w-5 h-5 text-yellow-500 mr-2" data-id="element-57" />
              <h3 className="text-lg font-medium text-gray-800" data-id="element-58">
                Automation Warning
              </h3>
            </div>
            <div className="p-4" data-id="element-59">
              <p className="text-sm text-gray-600 mb-2" data-id="element-60">
                This test will execute the actual automation. All actions
                defined in the automation will be run.
              </p>
              <p className="text-sm text-gray-600" data-id="element-61">
                Are you sure you want to continue?
              </p>
            </div>
            <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-62">
              <button onClick={() => setShowWarningModal(false)} className="px-4 py-2 border border-gray-200 rounded-md mr-2 text-sm font-medium" data-id="element-63">
                Cancel
              </button>
              <button className="px-4 py-2 bg-blue-500 text-white rounded-md text-sm font-medium" onClick={handleRunTest} data-id="element-64">
                Run Automation
              </button>
            </div>
          </div>
        </div>}
      {/* Add MCP Server Modal */}
      {showAddMCPModal && <AddMCPServerModal onClose={() => setShowAddMCPModal(false)} onAdd={handleAddMCPServer} data-id="element-65" />}
    </div>;
};